import { Label } from "@/components/ui/label";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/library/accordion";
import SearchableSelector from "@/components/ui/others/SearchableSelector";
import {
  useFilterValues,
  useNicheFilterUpdate,
} from "@/features/leads/components/leadFilter/context/FilterContext";
import useServices from "@/features/videoProduction/api/useServices";
import useVariants from "@/features/videoProduction/api/useVariants";
import { child_spesific_key } from "@/config/endpoints";
import CustomFieldFilters from "./CustomFieldFilters";
import HighlightText from "../HighlightText";
import { useIsSectionActive } from "../../context/AppliedFiltersContext";

export default function VideoProductionPreferences() {
  const sectionActive = useIsSectionActive("preference");
  const { nicheFilters } = useFilterValues();
  const updateNiche = useNicheFilterUpdate();
  const videoServiceId = (nicheFilters.videoServiceId as string) || "";
  const videoServiceVariantId =
    (nicheFilters.videoServiceVariantId as string) || "";
  const { serviceSelects, isLoading: servicesLoading } = useServices();
  const { variantSelects, isLoading: variantsLoading } = useVariants();

  return (
    <div className="flex flex-col overflow-hidden">
      <Accordion
        type="single"
        collapsible
        className="w-full"
        defaultValue={sectionActive ? "preferences" : undefined}
      >
        <AccordionItem value="preferences" className="border-none">
          <AccordionTrigger className="text-b3-mid font-semibold bg-transparent bg-[var(--color-green-1)] px-4 py-3 rounded-none hover:no-underline">
            <HighlightText text="Service Preferences" />
          </AccordionTrigger>
          <AccordionContent className="px-5 py-2 bg-white">
            <div className="space-y-[14px] px-2 pb-4">
              <div className="space-y-2">
                <Label className="text-[14px] leading-[1.35] tracking-[-0.56px] text-[#051912] font-normal mb-0 pb-1.5">
                  <HighlightText text="Service" />
                </Label>
                <SearchableSelector
                  value={videoServiceId || undefined}
                  onChange={(val) => updateNiche("videoServiceId", val)}
                  disabled={servicesLoading}
                  placeholder={servicesLoading ? "Loading..." : "Select service"}
                  searchInputPlaceholder="Search services..."
                  triggerClassName="h-10 bg-[#fcfcfc] border border-[var(--color-black-2)] rounded-[12px] px-3 py-2 text-[14px] leading-[1.35] tracking-[-0.56px] text-[#505e59] font-normal shadow-none hover:bg-[#fcfcfc]"
                  options={serviceSelects.map(
                    (option: { value: string; name: string }) => ({
                      value: option.value,
                      name: option.name,
                    })
                  )}
                />
              </div>

              <div className="space-y-2">
                <Label className="text-[14px] leading-[1.35] tracking-[-0.56px] text-[#051912] font-normal mb-0 pb-1.5">
                  <HighlightText text="Service Variant" />
                </Label>
                <SearchableSelector
                  value={videoServiceVariantId || undefined}
                  onChange={(val) =>
                    updateNiche("videoServiceVariantId", val)
                  }
                  disabled={variantsLoading}
                  placeholder={variantsLoading ? "Loading..." : "Select variant"}
                  searchInputPlaceholder="Search variants..."
                  triggerClassName="h-10 bg-[#fcfcfc] border border-[var(--color-black-2)] rounded-[12px] px-3 py-2 text-[14px] leading-[1.35] tracking-[-0.56px] text-[#505e59] font-normal shadow-none hover:bg-[#fcfcfc]"
                  options={variantSelects.map(
                    (option: { value: string; name: string }) => ({
                      value: option.value,
                      name: option.name,
                    })
                  )}
                />
              </div>

              <CustomFieldFilters
                queryKey={child_spesific_key}
                modelName="child"
                skipKeyFields
              />
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
